import { ActorRepository } from '../data/actor-repository';
import { ActorTree } from '../types/actor-types';

export class GetActorTreeUseCase {
  constructor(
    private readonly actorRepository: ActorRepository
  ) {}

  async execute(operatorId: string): Promise<ActorTree[]> {
    return await this.actorRepository.getActorTree(operatorId);
  }

  async executeWithCount(operatorId: string): Promise<{ actors: ActorTree[], totalCount: number }> {
    return await this.actorRepository.getActorTreeWithCount(operatorId);
  }
}
